export var baseURL = process.env.PUBLIC_URL;

export function setBaseUrl(url: string) {
    baseURL = url;
}
